/**
 *
 * @authors Your Name (you@example.org)
 * @date    220-10-09
 * @version $Id$
 */

import tipsMessage from './tipsMessage'

export default {
  tip_info: "Switch to English !",
  tip_type: "success",
  welcome: "Welcome To R3-OMS",
  username: "Username",
  password: "Password",
  login: "Sign in",
  logout: "Sign out",
  message: {
    hello: 'Hello World',
  },

  com: {
    total: 'Total',
    piece: 'items',
    all: 'All', //全部
    baseInformation: 'Base Info', //Base Info
    cancel: 'Cancel', //取消
    cancelled: 'Cancelled', //已取消
    submitted: 'Submitted', //已提交
    city: 'City',
    close: 'Close', //关闭
    consigneeInformation: 'Consignee Info', //收货人信息
    copy: 'Copy', //复制
    custAudited: 'Customer Audited',
    delivered_or_not: 'Check all',
    detailed_info: 'Detail Info',
    details: 'Details', //详情
    determine: 'Determine', //确定
    downloadNow: 'Download Now',
    endDate: 'End Date',
    exclude_province: 'Exclude Province',
    exclude_region: 'Exclude Region',
    financeAudited: 'Finance Audited',
    journal: 'Journal', //
    more: 'More', //更多
    no: 'No', // 否,NO
    province: 'Province',
    refresh_succee: 'Refresh Succee', //刷新成功 ,Refresh Succee
    region: 'Region',
    remarksInfo: 'Remarks Info', //备注信息
    return: 'Return', //返回
    reviewed: 'Reviewed', //已审核
    searching: 'Searching',
    selectAll: 'Check all',
    startDate: 'Start Date',
    tag: 'Tag', //标签
    tips: 'Tips', //提示
    to: 'To', //至
    toBeReviewed: 'To be Reviewed', //待审核
    unAudit: 'Unaudited', //未审核
    voided: 'Cancelled',
    warning: 'Warning', //警告
    yes: 'Yes', //是 ,YES
    address: {
      placeName0: 'Hangzhou',
      province0: 'Zhejiang Province',
      city0: 'Hangzhou City',
      erea0: 'Yuhang District',
      addressDetails0: 'Small Post Office, Building 2, Le Jia International Building, 999 Liang Mu Road',
      mobile0: '13012345678',
      phone0: '057112345678',
      name: 'Dried baby is loveliest',
      placeName1: 'Hangzhou',
      province1: 'Zhejiang Province',
      city1: 'Hangzhou City',
      erea1: 'Yuhang District',
      addressDetails1: 'Small Post Office, No. 5, Alibaba Taobaocheng, No. 1001, Wenyi West Road',
      mobile1: '13012345678',
      phone1: '057112345678',
      name1: 'Alibaba',
    },
  },

  other: {
    a0: '',
    a1: 'Empty the detail',
    a2: '',
    a3: '',	
    a4: '',
    a5: '',
    a6: '',
    a7: 'Type of commodity source',
    a8: '',
    a9: '',
    aa: '',
    ab: '',
    ac: 'Unlimited',
    ad: 'With money only',
    ae: 'Same tag price only',
    af: 'Numbers',
    ag: 'Merchants optimal',
    ah: 'Customers the best',
    ai: 'Gradient to send',
    aj: '',
    ak: 'VIP birthday only',
    al: 'VIP birthday week only',
    am: 'VIP birthday month only',
    an: 'All changed',
    ao: '',	
    ap: '',
    ak: '',	
    ar: 'Rule out goods',
    as: '',
    at: '',	
    au: '',
    av: 'For members only',
    aw: 'Whether the integral',
    ax: 'Stores files',
    ay: 'Levels of membership',
    az: 'Save the line',
    b0: 'Delete the selected row',	
    b1: '',
    b2: 'Goods cannot be empty',	
    b3: 'Specials cannot be empty',
    b4: 'A maximum of 10000 pieces of data can be imported',
    b5: 'Stage 3',
    b6: 'Stage 6',
    b7: 'Stage 12',
    b8: 'Ranked in the',	
    b9: 'between',
    ba: 'Standard merchandise file',
    bb: 'Coupon',
    bc: 'Free admission',
    bd: 'Present integral',	
    be: 'Greater than or equal to',
    bf: 'be greater than',
    bg: 'be equal to',
    bh: '',
    bi: 'Purchase',
    phoneNumber: 'Phone',
    user: 'Username',
    pwd: 'Password',
    verticalCode: 'SMS Code',
    pwdLogin: 'Password login',
    vCodeLogin: 'SMS login', // 验证码登录
    live: 'Live',
    fixedBudget: 'Predetermined',
    allAdvance: 'Full-pre',
    selfPrediction: 'Self-pre',
    queryResults: 'Query Results',
    fullPayment: 'Full Payment',
    activity_overview: 'Activity overview',
    addTo_original_remarks: 'Add to original remarks',
    basicActivity: 'Basic Activity',
    basic_info: 'Basic Info',
    billCode: 'Bill Code',
    billTime: 'Bill Time',
    blessingBag: 'Blessing Bag',
    color: 'Color', //颜色
    common: 'Common',
    condition_info: 'Conditon Info',
    confirmPrinting: 'Confirm Printing',
    day: 'Day',
    Designated_free_purchase: 'Designated free purchase',
    download_template: 'Download Template',
    downloadMethod: 'Download Method',
    draft_status: 'Draft State',
    exchangeAmounts: 'Exchange Amounts',
    exchangeQuantity: 'Exchange Quantity', //换货数量
    fixed_settlement: 'Fixed Settlement',
    gift_info: 'Gift Info',
    gift_list: 'Gift List',
    gift_set: 'Gift Set',
    goods_quantity: 'Goods Quantity',
    goods: 'Goods', //商品
    hour: 'Hour',
    info_set: 'Info Set',
    legend: 'Legend',
    minute: 'Minute',
    myMission: 'My mission', //我的任务
    newWarehouse_change: 'New warehouse change',
    no_double: 'Don’t double',
    noDataAvailable: 'No date available',
    offline_expired_status: 'Offline expired status',
    offline_expired: 'Offline expired',
    orderState: 'Order State',
    originalWarehouseOutOfStock_change: 'Original warehouse out of stock change',
    otherAmounts: 'Other Amounts', //其他金额
    override_original_remarks: 'Override original remarks',
    participating_goods: 'Participating Goods',
    payment_date: 'Payment Date',
    platformDelivery: "Platform Delivery", //平台发货
    postage_compensation: 'Postage Compensation',
    postage: 'Postage',
    price_compensation: 'Price Compensation',
    printing: 'Printing',
    product_list: 'Product List',
    product_related_info: 'Product related information',
    piece: 'Piece',
    refundablePostage: 'Refundable Postage', //应退邮费
    refundAmountGoods: 'Refund amount goods',
    refundNumber: 'Refund Number',
    returnGood: 'Refund Goods',
    sales_price: 'Sales Price',
    sendAll: 'Send all',
    settlementAmountConsignment: 'Settlement amount consignment', //代销结算金额
    shop: 'Shop', //店铺
    simulation_order_setup: 'Simulation order setup',
    size: 'Size',
    sizes: 'Sizes', //尺寸
    submission_status: 'Submission Status',
    systemCommodity_SKU: 'System commodity SKU',
    systemNotes: 'System Notes', //系统备注
    systemVoid: 'System Void', //系统作废
    sysWrongJudgment_change: 'System wrong judgment change',
    toBeDelivered: 'To be delivered',
    total: 'Total', //合计
    totalAmountReturnOrder: 'Total amount return order', //退货单总金额
    trialCalculation_results: 'Trial calculation results',
    unlimited: 'Unlimited',
    upload_files: 'Upload Files',
    uploadVoucher: 'Upload Voucher', //上传凭证
    view_log: 'View Log',
    warehouseDelivery: "Warehouse Delivery", //仓库发货 
    nonMatchingGoods: 'Non matching goods', // 非搭配商品
    preSale: 'Presale', // 预售
    depositTime: 'Deposit Time', // 定金时间
    buyAndGive: 'Buy and Give', // 全场买赠
    excludeFollowingItems: 'Exclude the following goods', // 排除以下商品
    outOfStock: 'Out of stock',
    RefundSuccessful: 'Refund Successful',
    payType: 'Pay Type',
    auditError: 'Audit Error',
    multipleOutOfStock: 'Multiple out of stock',
    manual: 'Manual',
    noDefectiveProductAllocation: 'No defective product allocation',
    defectiveProductsAllocated: 'Defective products allocated',
    defectiveProductsNotAllocated: 'Defective products not allocated',
    platForm: 'Platform',
    warehousingLogicalWarehouse: 'Warehousing logical warehouse',
  },

  btn: {
    newSKU: 'New SKU',
    fastNew: 'Fast addition',
    applyToAllColumn: 'Apply to all columns',
    addManually: 'Add Manually',
    replaceDetail: 'Replace Detail',
    addGoods: 'Add Goods',
    designGoods: 'Design Goods',
    forceMatching: 'Force Match',
    searchReturnOrder: 'SearchReturnOrder',
    clearReturnOrder: 'ClearReturnOrder',
    previous: 'Previous',
    next: 'Next',
    authorityYes: 'Authority Success',
    authorityNo: 'Authority Failed',
    addDetail: 'Add Detail',
    deleteDetail: 'Delete Detail',
    markCancel: 'Mark Cancel',
    preSaleBalancePaid: 'Presale balance paid',
    nonPreSale: 'Non Presale',
    cashOnDelivery: 'Cash on delivery',
    add_collocation: 'Add Collocation',
    add_ladder: 'Add Ladder',
    add: 'Add', //新增
    addGift: "Add Gift", //添加赠品
    additionalRefund: 'Additional Refund', //额外退款
    add_splitOrder: 'Add split order', //添加到待拆单
    afterSalesAudit: 'After sales audit', //售后审核
    appointGoods_splitOrder: "Appoint goods split order", //指定商品拆单
    audit: 'Audit', //审核
    back: 'Back',
    batch_add: 'Batch Add', //批量新增
    batch_chargeback: "Batch Chargeback", //批量退单
    batch_holdOrder: 'Batch hold order', //批量Hold单
    batchModify_logistics: 'Batch modify logistics', //批量修改物流
    batchModify_remarks: 'Batch modify remarks', //批量修改备注
    batchModify_warehouse: 'Batch modify warehouse', //批量修改仓库
    batchModify: 'Batch modify',
    batchModifyGoods: "Batch modify goods", //批量改商品
    batchOriginalReturn: 'Batch original return', //批量原退
    batchSplitOrder: "Batch split order", //批量拆单
    batch_addGift: "Batch add gift", //批量添加赠品
    batch_deleteGift: "Batch delete gift", //批量删除赠品
    batch_replaceGoods: "Batch replace goods", //批量替换商品
    beOut_of_stock: 'Be out of stock', //缺货重新占单
    copyPermissions: 'Copy Permissions',
    cancel_automaticRefund: 'Cancel automatic refund', //取消自动退款
    cancel_mergeOrders: "Cancel merge orders", //取消合并订单
    cancelBlocking: 'Cancel Blocking', //取消拦截
    cancelHold: 'Cancel Hold', //取消Hold
    batch_cancelHold: 'Batch cancel Hold', //批量取消Hold
    changeAddress: 'Change Address', //修改地址
    changeTo_platformShipment: "Change to platform shipment ", //更改为平台发货
    collection: "Collection", //收藏
    copyOrder: "Copy order", //复制订单
    confirm_splitOrder: "Confirm spilt order", //确认拆单
    createOrder: 'Create order', //创建订单
    custAudit: 'Custmer Audit',
    dealInOrder_download: 'Deal in order download',
    deAudit: 'Deaudit', //反审核
    deCustAudit: 'Decustaudit',
    delete_collocation: 'Delete Collocation',
    delete_ladder: 'Delete Ladder',
    delete: 'Delete',
    deleteGift: "Delete Gift", //删除赠品
    distributionChargeback_download: 'Distribution changeback download',
    distributionOrder_download: 'Distribution order download',
    distributionProduct_download: 'Distribution product download',
    download: 'Download',
    downloadProgressBill: 'Download progress bill',
    draft: 'Draft',
    empty: 'Empty', //清除
    expedited_shipment: 'Expedited shipment', //加急发货
    export: "Export", //导出
    financeAudit: 'Finance Audit',
    find: 'Find',
    forcedStorage: 'Forced Storage',
    fubaoOut_of_stock: 'Blessing Bag out of stock', //福袋缺货重新占单
    generalGoods_download: 'Genera goods download',
    generalOrder_download: 'Genera order download',
    generate: 'Generate',
    giftDelivery_copy: "Gift delivery copy", //赠品出库复制
    holdOrder: 'Hold order', //hold单
    import: "Import", //导入
    increase: "Increase", // 添加
    invoiceNotice: 'Invoice Notice', //开票通知
    lostOrder_copy: 'Lost order copy', //丢单复制
    mandatoryCompletion: 'Mandatory Completion', //强制完成
    manual_matching: 'Manual Matching',
    manualCreation: 'Manual Creation', //手工创建
    manualMarking: 'Manual Marking', //手工打标
    mark_efective_product_transferred: 'Mark efective product transferred',
    mergeOrders: "Merge order", //合并订单
    missedCopy: "Missed Copy", //漏发复制
    modify_logistics: 'Modify Logistics',
    modify_returnWarehouse: 'Modity return warehouse', //修改退回仓库
    modify: 'Modify', //修改
    modifyRemarks: 'Modify Remarks', //修改备注
    modifyWarehouse: 'Modify Warehouse', //修改仓库
    modify_sellerNotes: 'Modify seller notes', //修改卖家备注
    monthlyBillDownload: 'Monthly bill download',
    new_chargeback: 'New chargeback', //新增退单
    new_workOrder: 'New work order', //新增工单
    note_import: 'Note Import', //备注导入
    offline: 'Offline',
    orderBlocking: 'Order Blocking', //订单拦截
    orderCancel: 'Order Cancel', //订单取消
    original_single_null_and_void_copy: "Original single null and void copy", //原单无效复制
    out_of_stock_splitOrder: "Out of stock split order", //缺货拆单
    overdue: 'Overdue',
    order_detailed: 'Order detailed', //订单明细
    publish: 'Publish',
    published: 'Published',
    preSaleAdvanceDeliveryMarking: 'Presale advance delivery marking', //定金预售提前发货打标
    query: 'Query',
    rark_refundComplete: 'Rark refund complete',
    recordInvoice: 'Record Invoice', //记录发票
    refresh: 'Refresh',
    release_inventory: "Release Inventory", //释放库存
    replaceGoods: "Repiace Goods", //替换商品
    changeGoods: 'Change Goods',
    reset: 'Reset',
    retransmission_WMS: 'Retransmission WMS', //重传WMS
    returnCopy: 'Return Copy', //退换货复制
    save: 'Save',
    saveDraft: 'Save Draft',
    search: 'Search', //搜索
    sellerNotesImport: 'Seller notes inport', //卖家备注导入
    set_groups: 'Set Groups',
    cancel_groups: 'Cancel Groups',
    simulation_trial_calculation: 'Simulation trial calculation',
    simulation: 'Simulation',
    splitOrder: 'Split Order', //拆分订单
    sortForm: 'Sort Form', //排序表单
    text: 'Text',
    virtualWarehous: 'Virtual Warehouse', //虚拟入库
    void: 'Void',
    wrong_sending_forced_matching: 'Wrong sending forced matching',
    wrongCopy: "Wrong Cpoy", //错发复制 
    show: 'Show',
    hide: 'Hide',
  },

  pH: {
    a0: '（For empty do not do control, the key words in turn to fill in the Chinese ";" separated）',
    a1: 'Select date range',
    a2: 'Username',
    a3: 'Password',
    a4: 'Please Enter',
    a5: 'Please enter the function name to search',
    a6: 'PhoneNumber',
    a7: 'Code',
    a8: 'SMS Code',
    a9: 'Get Code',
    aa: '',
    chargebackNumber: 'Please enter the return number',
    consignee: 'Please enter consignee',
    enter: 'Please enter ', //请输入 ,Please enter
    organizationCode_or_name: 'Please enter the organization code or name', //请输入机构编码或名称,Please enter the organization code or name
    phone_number: 'Please enter the phone number',
    userName: 'User name', //用户名,User name
    z0: 'Multiple platform order numbers, separated by commas',
    z1: 'Please enter the platform number',
    z2: 'Please select order status',
    z3: 'Multiple return order numbers, separated by commas',
    z4: 'Please enter the commodity SKU',
  },

  unit: { // 单位
    yuan: 'Yuan',
    volume: 'Volume(cm3)',
    grossWeight: 'GrossWeight',
    netWeight: 'NetWeight',
    unit: 'Unit',
  },

  menu: { // 菜单labelName
    a0: 'Logistics company files',
    a1: 'New logical warehouse',
    a2: 'New alias',
    a3: 'New Area',
    a4: 'Channel warehouse archives',
    a5: 'National provincial and municipal editors',
    a6: 'Combination blessing bag commodity editor',
    a7: 'Commodity SPU',
    a8: 'Product SKU',
    a9: 'Fast generation of SKU',
    aa: 'Product custom attributes',
    ab: 'Combined commodity',
    ac: 'Commodity classification',
    ad: 'Sales promotion',
    ae: 'New logistics regional settings',
    af: 'Warehouse logistics priority scheme added',
    ag: 'Express compensation scheme editor',
    ah: 'Store authorization',
    ai: 'Automatic order approval and editing',
    aj: 'Delivery order dispatching rules',
    ak: 'Vipshop early warning notice',
    al: 'Schedule planning',
    am: 'Warehouse logistics settings',
    an: 'Commodity price strategy',
    ao: 'Live broadcast analysis strategy',
    ap: 'Rules of warehouse Division',
    aq: 'Sub logistics rules',
    ar: 'Special logistics solutions',
    as: 'Scope of logistics delivery',
    at: 'HOLD Strategy',
    au: 'Tmall exchange strategy',
    av: 'Review strategy',
    aw: 'Delivery refund form editing',
    ax: 'Extra refund edit',
    ay: 'JIT distribution list - change hangtag',
    az: 'Return new',
    // b------------------------------------------------------------------------
    b0: 'Add return order',
    b1: 'SKU Edit',
    b2: 'SPU Edit',
    b3: 'Fast generate',
    b4: 'National Province City',
    b5: 'File editor of logistics company',
    b6: 'Channel warehouse edit',
    b7: 'Return order Edit',
    b8: 'Exchange order Edit',
  },

  pL: { // 面板title
    a0: 'Return Order',
    a1: 'Return or Exchange Order',
    a2: 'Return Order Details',
    a3: 'Chargeback number query',
    a4: 'Waiting for delivery',
    a5: 'Exchange for shipment',
    a6: 'Edit warehouse rules',
    a7: 'Commodity details',
    a8: 'Create content',
    a9: 'Receipt statement',
    aa: 'Create conditions',
    ab: 'Create by no picking',
    ac: 'Stock in order',
    ad: 'Picking list',
    ae: 'Execution action',
    af: 'Package properties',
    ag: 'Start >=',
    ah: 'End',
    ai: 'Range',
    aj: 'Default Logistics',
    ak: 'Document amount',
    al: 'Logistics Info',
    am: 'Package weight',
    an: 'Special Logistics Aolutions Add',
    ao: 'Automatic allocation',
    ap: 'Create by point in time',
    aq: 'Start Logistics',
    ar: 'Logistics distribution',
    as: 'Spare barcode',
    at: 'Basic info',
    au: 'Create picking list',
    av: 'Create stock in order',
    aw: 'Physical property',
    ax: 'Business info',
    ay: 'SKU info',
    az: 'supplier',
    // b------------------------------------------------------------------------
    b0: 'Supply logic warehouse',
    b1: 'Platform logistics correspondence',
    b2: 'Analysis logistics',
    b3: 'Create picking list',
    b4: 'Fixed attributes',
    b5: 'Custom properties',
    b6: 'Commodity dimension',
    b7: '',
    b8: '',
    b9: '',
    ba: '',
    bb: '',
    bc: '',
    bd: '',
    be: '',
    bf: '',
    bg: '',
    bh: '',
    bi: '',
    bj: '',
    bk: '',
    bl: '',
    bm: '',
    bn: '',
    bo: '',
    bp: '',
    bq: '',
    br: '',
    bs: '',
    bt: '',
    bu: '',
    bv: '',
    bw: '',
    bx: '',
    by: '',
    bz: '',
    edit_order_dispatch_rule: 'Edit order delivery rules',
    add_claimForm: 'Add Claim Form', // 赔付单新增,Add ClaimForm
    add_retail_shipping_order: 'Add retail shipping order', //零售发货单新增
    addPromotion: 'Add Promotion',
    addReturnOrder: 'Add Return Order', //退换货订单新增
    all: 'All',
    barCode_details: 'Bar code details',
    basicData: 'Basic Data', //基础资料
    batchAddPromotion: 'Batch Add Promotion',
    billingNoticeEdit: 'Billing Notice Edit', //开票通知编辑
    brand_authority: 'Brand Authority', //品牌权限，Brand authority,
    combinedCommodity_details: 'Combined commodity details',
    combinedCommodity_edit: 'Combined commodity edit',
    combinedCommodity: 'Combined Commodity',
    commodity_authority: 'Commodity Authority', //商品权限,Commodity authority
    company_authority: 'Company Authority', //公司权限,Company authority
    details_claimForm: 'Details Claim Form', // 赔付单详情
    distributionCenter_authority: 'Distribution center authority', //配销中心权限，Distribution center authority,
    editPromotion: 'Edit Promotion',
    enterInfo: 'Enter Info', //录入信息
    exchangeInfo: 'Exchange Info', //换货人信息
    express_compensation_scheme: 'Express compensation scheme',
    extraRefundEdit: 'Extra Refund Edit', //额外退款编辑
    forcedStorage: 'Forced Storage', //退换货订单
    generate_replacement_order: 'Generate replacement order',
    interface_download_taskTable_edit: 'Interface download tasktable edit',
    interface_download_taskTable: 'Interface download tasktable',
    log: 'Log',
    logisticsAreaSetting: 'Logistics Area Setting', //物流区域设置
    operationLog: 'Operation Log', //操作日志
    order_detailed: 'Order detailed', //订单明细
    orderManager_edit: 'Order Manager Edit', //订单管理编辑
    orderManager: 'Order Manager', //订单管理
    orderSplit: 'Order Split', //订单拆分
    payableAdjust_details: 'Payable Adjust Details', //赔付单明细
    payableAdjustmentList: 'Payable Adjustment List', //赔付单
    promotionList: 'Promotion List',
    refundSlipDetails: 'Refund Slip Details',
    retailInvoice_details: 'RetailIn Voice Details', //零售发货单详情
    retail_shipping_order: 'Retail Shipping Order', // 零售发货单
    return_warehousing_manual_matching: 'Return warehousing manual matching',
    return_warehousing_wrong_delivery_forced_matching: 'return_warehousing_wrong_delivery_forced_matching',
    returnAmount: 'Return Amount', //退货金额
    returnAndExchange_info: 'Return and exchange info', //退换货信息
    ReturnOrderDetails: 'Return and Exchange Order Details',//退换货订单新增
    returnTreasury: 'Return to storage',
    returnTreasuryAdd: 'New',
    returnTreasuryDetails: 'Return and warehousing details',
    role_authority: 'Role Rights',    //角色权限,Role authority
    scanDetails: 'Scan Details',    //扫描明细
    scanInfo: 'Scan for the Info',    //扫描信息
    scannAndWarehous: 'Scan for warehousing',    //扫描入库
    setWarehouseLogistics: 'Warehouse logistics priority settings',
    supplier_authority: 'Supplier Permissions',    //供应商权限,Supplier authority
    vipshopWarehouseEntry: 'Vipshop Warehouse order',
    warehouse_authority: 'Warehouse authority',    //店仓权限,Warehouse authority'
    warehouse_logistics_priority_scheme: 'Warehouse Logistics Priority Scheme',
    warehouse_receipt: 'Warehouse warehouse list',
    JITchangeBrand: 'JIT Distribution sheet replacement ter',
  },

  fL: {     //检索表单label
    // e------------------------------------------------------------------------
    e0: 'Fail Reason',
    e1: 'detailed info',
    e2: 'Estimated delivery time',
    e3: 'Automatically agree to exchange',
    e4: 'Automatic rejection of exchange',
    e5: 'Refund application time',
    e6: 'Telephone',
    e7: 'Zip code',
    e8: 'Platform transaction status',
    e9: '',
    // a------------------------------------------------------------------------
    a0: 'Receiving address is nearby',
    a1: 'Vipshop',
    a2: 'Warehouse Priority',
    a3: 'Shipping ratio',
    a4: 'Shipping quantity',
    a5: 'By receiving address',
    a6: 'Order Rule Details',
    a7: 'Divwarehouse ratio',
    a8: 'Hangzhou Store Warehouse',
    a9: 'Calculate inflated inventory',
    aa: 'Province & city',
    ab: 'Detailed address',
    ac: 'Non gift',
    ad: 'Refundable freight',
    ae: 'Total amount of final refund',
    af: 'Delivery physical warehouse',
    ag: 'Platform status',
    ah: 'Order amount',
    ai: 'Total amount of goods',
    aj: 'Total order amount',
    ak: 'Amount actually paid',
    al: 'Red envelopes',
    am: 'Collection of COD amount',
    an: 'Multi package',
    ao: 'Service number',
    ap: 'Store authorization',
    aq: 'Shop nickname',
    ar: 'Perfect information',
    as: 'Valid time of authorization',
    at: "Seller's name",
    au: 'Province',
    av: 'City',
    aw: "District/County",
    ax: "Seller's address",
    ay: 'Authorization guidelines',
    az: 'Add exclusion zone',
    b0: 'Switch to SKU product display',
    b1: 'Switch to platform product details',
    b2: 'Total retail price',
    b3: 'Commodity discount',
    b4: 'Order discount amount',
    b5: 'Supporting provinces',
    b6: 'Excluding provinces',
    b7: 'Delete area',
    b8: 'Scope of support',
    b9: 'Application time',
    ba: 'Product digital ID',
    bb: 'Province search',
    bc: 'Policy ID',
    bd: 'Policy name',
    be: 'Effective start time',
    bf: 'Effective end time',
    bg: 'Enable status',
    bh: 'Lowest transaction price',
    bi: 'Recognition rules',
    bj: 'Payment time',
    bk: 'Anchor ID',
    bl: 'Anchor nickname',
    bm: 'Order label',
    bn: '“Broadcast” sign',
    bo: 'Schedule name',
    bp: 'Planning start time',
    bq: 'Planning end time',
    br: 'Replenishment independent warehousing',
    bs: 'Vipshop warehouse',
    bt: 'Picking list type',
    bu: 'Dimension of UN picked quantity',
    bv: 'Create peak',
    bw: 'Automatic picking interval',
    bx: 'Replenishment order',
    by: 'Pre allocation',
    bz: 'Carrier',
    c0: 'Air embargo',
    c1: 'Delivery interval',
    c2: 'same day',
    c3: 'The next day',
    c4: 'Delivery time',
    c5: 'Arrival interval',
    c6: 'Arrival time',
    c7: 'Closing time of stock in order',
    c8: 'Dimension of vipshop warehouse under single Po',
    c9: 'PO dimension',
    ca: 'Air transport',
    cb: 'Motor transport',
    cc: 'Picking list creation method',
    cd: 'Live product identification',
    ce: 'Exchange address',
    cf: 'Exchange instructions',
    cg: '',
    ch: 'Deviation N yuan agree to exchange<=',
    ci: 'yes',
    cj: 'no',
    ck: 'Automatic rejection of out of stock',
    cl: 'Reasons for automatic rejection of replacement in case of shortage',
    cm: 'Out of stock auto reject copy',
    cn: 'Deviation n-ary automatic rejection',
    co: 'Deviation n yuan, refuse to exchange>',
    cp: 'Reasons for automatic rejection of exchange with deviation n yuan',
    cq: 'Error n-ary auto reject copy',
    cr: 'Actual refund amount of goods',
    cs: 'Total amount of final refund',
    ct: 'Order discount',
    cu: 'Retail price',
    cv: 'Query the original platform number',
    cw: 'Lowest transaction price',
    cx: 'PO number',
    cy: 'Combination commodity code',
    cz: 'Combination commodity name',
    // d------------------------------------------------------------------------
    d0: 'Combination type',
    d1: 'General combination details',
    d2: 'Details of blessing bag combination',
    d3: 'Number of samples per group',
    d4: 'Sales status',
    d5: 'Purchase price',
    d6: 'Cost price',
    d7: 'Default supplier',
    d8: 'Product introduction',
    d9: "Channel warehouse code",
    da: 'Name of channel warehouse',
    db: 'Supply ratio',
    dc: 'Area code',
    dd: 'Area name',
    de: 'Alias name',
    df: 'Area type',
    dg: 'Country',
    dh: 'Province',
    di: 'Municipal',
    dj: 'District',
    dk: 'Affiliated Province',
    dl: 'Affiliated City',
    dm: 'Related countries',
    dn: 'Related districts and counties',
    do: 'prefix',
    dp: 'suffix',
    dq: 'Platform logistics No',
    dr: 'Name of platform logistics',
    ds: 'Logistics company code',
    dt: 'Name of logistics company',
    du: 'Logic bin code',
    dv: 'Logical warehouse name',
    dw: 'Entity warehouse',
    dx: 'Warehouse type',
    dy: 'Main warehouse',
    dz: 'Negative inventory control',
    type: 'Type',
    ruleName: 'Rule Name',
    aconsignee_address: 'Ship nee Address',
    aconsignee_area: 'Ship nee Area',    //收货人区,
    activityDate: 'Activity Date',
    activityName: 'Activity Name',
    activityType: 'Activity Type',
    actualRefundAmount: 'Actual refund amount',    //实际退款金额
    addressee_phone: 'Attention Cell Phone',    //收件人手机
    addressee: 'To',    //收件人
    adjustmentType: 'Adjustment Type',
    adjustEndTime: 'Adjust End time',    //调整结束时间
    apply_refundAmount: 'Request for a refund amount',
    autoMatch: 'Automatic match automatically',    //是否自动匹配
    automaticRelease: 'Auto-release',
    bankAccountNo: 'Account number',
    bankOFdeposit: 'Bank of Account',
    bar_code_does_not_match: 'Shoe box barcode does not match the physical barcode',    //鞋盒条码与实物条码不符
    barCode: 'Barcode',    //条码
    bar_code: 'Barcode code',
    batchNumber: 'Batch Number',
    batch_number: 'Batch Number',
    billing_status: 'Inicing Status',
    billNo: 'Document Number',
    billStatus: 'Document Status',
    billType: 'Document Type',
    buyer_HOLD: 'Buyer HOLD Single',
    buyer_message: 'Buyers Message',
    buyerNotes: "buyer' s Note ",    //买家备注
    BuyerPhoneNumber: 'Buyer Cell Phone Number',    //买家手机号
    cellPhone_number: 'Mobile phone number',
    changeOrderModify_time: 'Change Order time',
    changeOrderStatus: 'Change Order Status',
    changeWarehouse_reasons: 'Reasons for the warehouse change',
    channelType: 'Channel Type',
    chargebackModifyTime: 'Unback modification time',
    chargebackNumber: 'Check-back number',    //退单编号
    chargebackStatus: 'Unback status',
    choose_product_ways: 'Select commodity mode',
    closingMan: 'Closing closing',
    closingTime: 'Closing time',
    collection_amount: 'Collection amount',    //代收金额
    combinedCommodityType: 'Combination of commodity types',
    commodityCode: 'Commodity Barcode',
    commodityID: 'Commodity ID',
    companyAddress: 'Company address',
    complete: 'Complete',
    confirmed_as_JITX: 'Confirm it as a JITX',
    confirmed_as_non_JITX: 'Confirm as a non-JITX',
    confirming: 'In the Confirmation',
    consignee_city: 'consignee City',   // 收货人市
    consignee_phone: 'Ship nee Phone',   // 收货人手机
    consignee_postcode: 'Ship nee Postal Code',   // 收货人邮编
    consignee_province: 'consignee Province',   // 收货人省份
    consignee_tel: 'Ship nee Phone',   // 收货人电话
    consignee: 'Ship nee',   // 收货人
    contactNumber: 'Contact phone number',   // 联系电话
    create_and_download: 'Create and download pick orders',
    creationDate: 'Creation Date',
    current_remarks: 'Current comments',
    custAuditDate: 'Guest Review Date',
    defectiveProduct_allocation_status: 'Secondary product allocation status',
    defectiveProductRecord: 'Secondary Product Records',
    deliverGoodsAddress: 'Shipping address',    //发货地址
    delivery_warehouse: 'Shipment Warehouse',    //发货仓库
    depositOrderNo: 'Deposit Order Number',
    distribution_costs: 'Delivery costs',    //配送费用
    distribution_logistics: 'Distribution and Logistics',    //配送物流
    distributionMode: 'Method of delivery',
    documentDate: 'Document Date',    //单据日期
    double_gifts: 'The giveaway is doubled',
    downloadOnly: 'Download pick orders only',
    downloadType: 'Download Type',
    delayDate: 'Extension Date',
    effectiveDate: 'Effective Date',
    electronic_invoice: 'E-Invoices',
    endDate: 'End Date',
    endTime: 'End Time',
    enterprise: 'Enterprise',
    exchangeDetails: 'Explacement details',
    exchangePending: 'Exchange to for processed',
    exchangePlatform_no: 'Exchange Platform Order Number',
    exchangePostage: 'Exchange postage',
    expressCompanyName: 'Express Company Name',    // Name of express company
    expressOutlets: 'Express outlets',
    financeAuditDate: 'Financial Review Date',
    free_quantity: 'Quantity of quantity',
    freight: 'Freight charges',
    fullName: 'Name',
    gBCode: 'National Standard Code',
    gift: 'Giveaways',
    giving_ways: 'Giving of ways',
    goods_participation_mode: 'Commodity participation methods',
    goods_source: 'Source of merchandise',
    goodsMark: 'Commodity mark',    //商品标记
    goodsName: 'Product Name',   // 商品名称
    goodsPID: 'Commodity PID',
    gradient_gift: 'The Gradient Gift',
    handler: 'The Handler',
    hOLD_reason: 'HOLD Single Cause',
    identificationNo: 'I-No.',
    in_order_stockNo: 'Warehouse No Number',
    in_warehouse: 'Storage warehouse',
    internalRemarks: 'Internal remarks',    //内部备注
    invoice_or_not: 'invoiced',   // 是否开票
    invoice_remarks: 'Invoice Notes',
    invoice_type: 'Invoice Type',
    invoiceTitle_type: 'Head-Up Type',
    invoiceTitle: 'Invoice Head-Up',
    is_there_no_original_barcode: 'Is there no original single barcode',   // 是否无原单条码
    issueBarcode: 'Issue bar barcode',    //发出条码
    ladderType: 'Staadder Type',
    live_HOLD: 'Live HOLD Single',
    logic_warehouse: 'The Logic Warehouse',
    logisticsCompany: 'Logistics Company',
    logisticsNo: 'Logistics Number',
    logisticsOrder_No: 'Logistics Order Number',    //物流单号
    lotType: 'Batch Type',    //批次类型
    mailbox: 'Email',
    match_smart_address: 'Smart Matching Address',    //智能匹配地址
    max_doubling_times: 'Maximum doubling times',
    max_times: 'Maximum times',
    meet_conditions: 'Condition is met',
    modify_remarks: 'Modify the comments',
    multiple: 'Multiple',
    namePayee: 'Name of the payee',   // 收款人姓名
    newlyBuild: 'New',
    normal: 'Normal',   // 正常
    numberCode: 'Number Number Number',
    offline_stores: 'Offline stores',
    offlineTime: 'Offline time',
    one_participation_times: 'Number of participation of individual buyers',
    operator: 'Operator',
    order_notes: 'Order Notes',
    orderNumber: 'Order Number',    //订单号
    orderShop: 'Ordering Store',    //下单店铺
    orderType: 'Order Type',
    order_time: 'Order Time',
    out_date: 'Delivery date',
    original_out_date: 'Original outbound date',
    originalDeliveryWarehouse: 'Original Shipping Warehouse',
    originalOrder_No: 'Original single number',    //原单单号
    originalOrderNo: 'Original Order Number',    //原始订单编号
    originalOrderPlatform: 'Original Platform Single Number',    //原平台单号
    originalPlatformNo: 'Original platform single number',    //原始平台单号
    ownership: 'Schedule attribution',
    paper_invoice: 'Paper Invoices',
    payableAdjustReason: 'Cause for compensation',
    payableAdjustStandard: 'Compensation Standards',
    payableAdjustType: 'Type',
    payment_info: 'Payment Info',    //支付信息
    paymentMethod: 'Method of Payment',    //付款方式
    personal: 'Individuals',
    phone_number: 'Cell Phone Number',    //手机号码
    physicalWarehouseFile: 'Entity Warehouse archives',
    physicalWarehouseName: 'Entity Warehouse Name',
    pickingOrder_no: 'Pick-Up Order No.',
    platform_billNo: 'Platform single Number',
    platform_marking: 'Platform marking',
    platform_returnOrder_no: 'Platform Return Form Number',
    platformCommodityID: 'Platform merchandise ID',
    platformExchangeOrder_no: 'Platform Change Order No.',
    PlatformModifyTime: 'Platform modification time',
    platformProductsCode: 'Platform Product Code',
    platformProductsName: 'Platform Product Name',
    platformRefundNo: 'Platform refund back Number',
    platformTime: 'Platform time',
    platformType: 'Platform Type',
    preferential_info: 'Preferential Info',    //优惠信息
    price: 'Price',
    processor_remarks: 'Handessor Notes',
    promotion_status: 'Promotional Status',
    processing_status: 'Processing Status',
    promotionNo: 'Promotional Number',
    proReturnStatus: 'Return Status',
    purchase_ranking: 'Purchase rankings',
    purchaseQuantity: 'Purchase Quantity',   // 购买数量
    qualityGoods: 'Genuine Products',    //正品
    queryTime: 'Query time',
    orderTime: 'Order time',
    reasonRefund: 'Refund reasons',    //退款原因
    receiptAddress: 'Ticket Collection Address',
    receivedBarcode: 'Paid-in Barcode',    //实收条码
    receivedGBcode: 'paid-in national standard code',    //实收国标码
    receiver_mobileNo: 'Ship nee Phone number',
    receiving_province: 'Receiving province',
    refundAmount: 'Refund Amount',    //退款金额
    refundClass: 'Money back Category',   // 退款分类
    refundDescription: 'Reback Description',    //退款描述
    refundNoteDelivered: 'Money back order shipped',    //已发货退款单
    refundOnly: 'Refund only',
    refundType: 'Refund Type',
    region_details: 'Regional Details',
    release_after_fixedTime: 'Release after fixed time',
    release_specified_timePoint: 'Specify the time point release',
    release_timePoint: 'Point on release',
    remarks_content: 'Remarks',
    remarksResponsibleParty: 'Remparty remarks',    //判责方备注
    reservedStockExchange: 'Replacement Inventory',
    responsibleParty: 'The judging party',    //判责方
    returnBatch: 'Return Lot',    //退货批次
    returnDetails: 'Return Details',
    returnLogisticsCompany: 'Return Logistics Company', //退回物流公司
    returnLogisticsNumber: 'Return Logistics Number',
    returnNo: 'Return Number',
    returnNotes: 'Return Notes', //退换货备注
    returnOrder_no: 'Return Oder Number', //退换货单号
    returnOrderLog: 'Return Oder Log', //退货单日志
    returnQuantity: 'Return Ouantity', //退货数量
    returnRefund: 'Refunds',//退货退款
    returnInformation: 'Return Info',//返回信息
    reviewer: 'Reviewer',//审核人
    routing_info: 'Routing Info', //路由信息
    salesReturn_to_warehouse: 'Sell Back Into Warehouse', //销退入库仓
    scansNumber: 'Scan The Number', //扫描数量
    scheduleOwnership: 'Schedule attribution',//档期日程归属
    schemeDescription: 'Scheme Described',//方案描述
    schemeName: 'Scheme Name',//方案名称
    sellerNotes: 'Seller Note', //卖家备注
    sending_address: 'Sending Address',//发件地址
    service_charge: 'Service Charge', //服务费
    settlement_price: 'Settlement Price',//结算价
    shipPhysicalWarehouse: 'Physical Warehouse For Delivery',//发货实体仓库
    shipping_info: 'Delivery Info', //发货信息
    skuName: 'SKU Name', //SKU名称
    source_billNo: 'Source Document Number',//来源单据编号
    sourceDocuments: 'Source Documents', //单据来源
    sourceNo: 'Source Number', //来源单号
    special_invoice: 'Special Invoice',//专用发票
    specialTreatmentType: 'Special Treatment Type', //特殊处理类型
    specs: 'specifications', //规格
    status_in_warehouse: 'Positions Within The State', //仓内状态
    startTime: 'Start Time', //开始时间
    staySellerAgrees: 'Stay Seller’s Agree', //待卖家同意
    store: 'Store', //门店
    storeID: 'Store ID',//店铺ID
    supplierID: 'Supplier ID',//供应商ID
    synchronizationStatus: 'Synchronization Status',//同步状态
    synchronizedInventory: 'Synchronous inventory',//同步库存数
    telephoneNumber: 'Telephone Number',//电话号码
    ticket_info: 'Ticket Info',//收票信息
    timeRange: 'Time Range',//时间范围
    timeType: 'Time Type',//时间类型
    transactionAmount: 'Transaction Amount', //成交金额
    transportationMode: 'Transportation Mode',//运输方式
    undeliveredCancel: 'Undelivered Cancellation',//未发货取消
    ungraded: 'Ungraded', //次品
    virtual_barcode: 'Virtual Barcode', //虚拟条码
    waitFor_afterSale_confirm: 'Wait For After-sales Confirm', //等待售后确认
    waitFor_afterSale_review: 'Wait For After-sales Review', //等待售后审核
    waitFor_return_warehous: 'Wait For Return Warehousing', //等待退货入库
    warehouse: 'Warehouse', //仓库
    warehousingEntity: 'Entering The Physical Warehouse', //入库实体仓库
    whether_returned: 'Whether The Original Back', //是否原退
    wMS_billNo: 'WMS Receipt Number', //WMS单据编号
    workOrder: 'Work Order', //工单
    wrongOrNot: 'Wrong Or Not', //是否错误
    payAccount: 'Payment Account', //支付账号
  },

  tL: {//'Table Header, Table Footer, Table Statistics' // 表头、表脚、表统计
    itemNo01: 'SPU Code', //SPU 编码
    itemNo02: 'SPU Name', //SPU 名称
    a0: 'Initial Salable Amount', //期初可售数
    a1: 'Number Of Change', //变化数量
    a2: 'Ending Amount Available For Sale', //期末可售数
    a3: 'Schedule Ownership Name', //日程归属名称
    a4: '实体可用数量',
    internationalCode: 'International Code', //国际码
    abbreviation: 'Abbreviation', //简称
    abnormalInfo: 'Abnormal Info', //异常信息
    activity_period: 'Active Time Period', //活动时间段
    actual_barcode: 'Actual Barcode', //实际发出条码
    actual_transactionPrice: 'Actual Transaction Price', //实际成交价
    add_manually: 'Whether Added By Hand', //是否手工新增
    adjustment_amount: 'Adjust Amount', //调整金额
    aequenceNo: 'Serial Number', //顺序号
    after_modification: 'after Modification', //修改后
    alipay: 'Alipay Number', //支付宝号
    amountDue: 'Amount Payable', //应付金额
    appleNumber: 'Application Quantity', //申请数量
    articleNumber: 'Article Number', //货号
    auditTime: 'Audit Time', //审核时间
    before_modification: 'Before The Modification', //修改前
    brand: 'Brand', //品牌
    buyerNickname: "Buyers' Nickname", //买家昵称
    check_mainStore: 'Check The Main Store', //查看主店仓
    code_SKU: 'SKU Code', //SKU 编码
    code: 'Code', //编码
    commodityDataNo: 'Commodity Data Number', //商品数据编号
    commoditySKU: 'Commodity SKU',//商品 SKU
    companyCode: 'Company Code', //公司编码
    companyName: 'Company Name', //公司名称
    compensation_expressCompany: 'Pay The Courier Company',//赔付快递公司
    creationTime: 'Creation Time', //创建时间
    creator: 'Creator',//创建人
    custAuditMan: 'Guest Auditor',//客审人
    custAuditTime: 'Guest Review Time', //客审时间
    custName: 'Customer Name',//顾客姓名
    custTelephone: 'Customer Telephone',//顾客电话
    discount: 'Discount',//折扣
    delivered_quantity: 'Quantity Already Delivered',//已送数量
    deliveryWarehouse_code: 'Shipping Warehouse Code',//发货仓库编码
    deliveryWarehouse_name: 'Shipping Warehouse Name',//发货仓库名称
    description: 'Description', //说明
    distribution_amount: 'Distribution Amount',//分销金额
    distributionCenterCode: 'Distribution Center Code', //配销中心编码
    distributionCenterName: 'Distribution Center Name', //配销中心名称
    distributionTime: 'Distribution Time', //配货时间
    edit: 'Edit', //编辑
    equal_amount: 'Aamortized Amount',//平摊金额
    exchangeQuantity: 'Quantity Quantity', //换货数量
    expressCode: 'Express Code',//快递编码
    expressCompany: 'Express Company',//快递公司
    expressName: 'Express Name',//快递名称
    expressNo: 'Express Number',//快递单号
    extendedProperties: 'Extended Properties',//扩展属性
    failure_offline_time: 'Failure Offline Time',//失效下线时间
    financeAuditMan: 'Finance Audit Man',//财审人
    financeAuditTime: 'Finance Audit Time', //财审时间
    flag: 'Flag', //旗帜
    gender: 'Gender', //性别
    generate_adjustment: 'Generate An Adjustment Order',//是否生成调整单
    generate_error_adjustment: 'Generate An Error Adjustment Order',//是否生成错发调整单
    generate_punching_headless_adjustment: 'Whether To Generate A Headless Adjustment Order',//是否生成冲无头件调整单
    generate_stock: 'Generate A Warehouse Order',//是否生成入库单
    giftItemCode: 'Giveaway Product Code',//赠品商品编码
    giftItemName: 'Gift Product Name',//赠送商品名称
    given_total_quantity: 'Total Gift Quantity',//赠送总计数量
    goodsInfo: 'Commodity Info', //商品信息
    grouping: 'Grouping',//分组
    groupName: 'Group Name',//分组名称
    in_warehouse_goods_details: 'Details Of Warehousing Order',//入库单商品明细
    itemNo: 'Item Number',//商品款号
    logContent: 'Log Content',//日志内容
    logicWarehouse: 'Logic Warehouse',//逻辑仓
    mainStore_warehouse: 'Main store warehouse', //制单主店仓
    match_or_not: 'Match Whether Or Not',//是否匹配
    materialShortage: 'Material Shortage',//实物报缺
    modificationTime: 'Revision Time',//修改时间
    new_address: 'New Address',//新地址
    new_detailed_address: 'New Detailed Address',//新详细地址
    new_receivingInfo: 'New Receiving Info',//新收货信息
    no_original_barcode: 'Is There No Original Single Barcode',//是否无原单条码
    number_of_rows_per_group: 'Number Of Drawn Rows Per Group',//每组抽取行数
    operation_description: 'Operation Description',//操作描述
    operation: 'Operation',//操作
    operatorName: 'Operator Name',//操作姓名
    operatorTime: 'Operator Time',//操作时间
    orderIdentification: 'Order Identification',//订单标识
    orderNo: 'Order Number',//订单编号
    orderQuantity: 'Order Quantity',//订单数量
    orderTime: 'Order Time', //下单时间
    original_deliveryWarehouse: 'Original Delivery Warehouse', //原发货仓库
    original_groupName: 'Original Group Name', //原分组名称
    outOfStock_quantity: 'Out Of Stock Quantity',//缺货数量
    participating_stores: 'Participating Shops',//参与店铺
    payable_unitPrice: 'Unit Price Payable',//应付单价
    paymentTime: 'Payment Time', //付款时间
    paymentWay: 'Payment Way',//支付方式
    per_given_quantity: 'Quantity Presented Per Time',//每次赠送数量
    physical_warehouse: 'Physical Warehouse',//实体仓库
    physicalWarehouse: 'Physical Warehouse',//实体仓
    platform_barcode_ID: 'Platform Bar Code ID'//平台条码ID
    , platform_model_ID: 'Platform Model ID',//平台款号ID
    platform_orderNo: 'Platform Single Number', //平台单号
    platformInfo: 'Platform Info', //平台信息
    platform_store_title: 'Platform Store Title',//平台店铺标题
    preferential_amount: 'Discount Amount', //优惠金额
    priority: 'Priority',//优先级
    product_title: 'Product Title',//商品标题
    productName: 'Product Name', //商品名称
    productNo: 'Product Number', // SPU编码
    productSKUname: 'Product SKU Name',//商品SKU名称
    promotionName: 'Promotion Name',//促销名称
    quantities: 'Quantity',//数量
    quantity_availableSale: 'Quantity Available',//可售数量
    quantity_demolished: 'Quantity To Be Dismantled',//待拆数量
    quantity_split: 'Split Quantity',//拆分数量
    receivingInfo: 'Receiving Info', //收货信息
    refund_status: 'Refund Status',//退款状态
    remarks: 'Remarks',//备注
    replicationReason: 'Copy Reason', //复制原因
    rest_sent: 'Remrest Can Be Delivered',//剩余可送
    return_warehousing_log: 'Return To The Entry Log',//退货入库日志
    returnGood: 'Return Goods',//退货
    returnGoods: 'Changing Or Refunding',//退换货
    revised_content: 'Revise Content',//修改内容
    reviser: 'Reviser',//修改人
    roles: 'Roles', //角色
    rows: 'ROWS', //行
    scanDeliveryTime: 'Scan For The Outbound Time', //扫描出库时间
    seller_nickname: "Seller's Nickname",//卖家昵称
    sensitiveColumn: 'Sensitive Column', //敏感列
    serialNo: 'NO', //序号
    settlementAmount: 'Settlement Amount',//结算金额
    shippingAddress: 'Shipping Address', //收货地址
    shopName: 'Shop Name',//店铺名称
    standardPrice: 'Standard Price',//标准价
    status: 'Status',//状态
    stock: 'Stock',//库存
    storageQuantity: 'Storage Quantity',//入库数量
    storehouse: 'Storehouse', //店仓
    supplier_fullName: "Supplier's Full Name", // 供应商全称
    supplierCode: 'Supplier Code', //供应商编码
    supplierName: 'Supplier Name', // 供应商名称
    suggested_deliveryWarehouse: 'Recommended Warehouse Warehouse', // 建议发货仓库
    tagPrice: 'Tag Price', //吊牌价
    total_amountDue: 'Total Amount Payable',//总应付金额
    total: 'TOTAL', //总计
    totalOrderAmount: 'Total Order Amount', //订单总额
    totalSettlement: 'Total Settlement',//结算总额
    transactionAmount: 'Transaction Amount', //成交金额
    turnOff_match: 'Whether To Turn Off The Match',//是否关闭匹配
    unitPrice: 'Transaction Unit Price',//成交单价
    unitPriceSettlement: 'Settlement Unit Price',//结算单价
    unitReturnAmount: 'Single-item Return Amount',//单件退货金额
    usable: 'Usable',//可用
    view: 'View', //查看
    vip_nickname: 'Member Nickname',//会员昵称
    voidMan: 'Void Man',//作废人
    voidTime: 'Void Time',//作废时间
    warehouseName: 'Warehouse Name',//仓库名称
    warehouseNo: 'Warehouse Number',//仓库编号
    whetherGift: 'Giveaway Or Whether', //是否赠品
  },

  mT: { // 弹窗title
    ai: 'Other platforms',
    ah: 'Batch replacement of hanging goods',
    ag: 'After sale copy',
    af: 'New store',
    ae: 'The documents meeting the following conditions are marked with "broadcast"',
    ad: 'Documents meeting the following conditions will be processed as hold documents',
    ac: 'Add item - selected',
    ab: 'Warehouse division strategy - Import',
    aa: 'Clear the failure prompt box',
    ab: 'Warehouse division strategy - Import',
    ac: 'Add item - Selected',
    th1: "Replace The Previous Merchandise",//替换前商品
    th2: "Replacement Ptem",//替换后商品
    a0: 'Special Setting Details Of The Store Goods', // 店铺商品特殊设置明细
    a1: 'Replaced Goods SKU', // 被替换商品SKU
    a2: 'Batch New Condition Info Import', // 批量新增条件信息导入
    a3: 'Please Select A Warehouse',//请选择仓库
    a4: 'Replacement Item SKU',//替换后商品SKU
    a5: 'Error Reporting Message',//报错信息
    a6: 'Prompt Message ',//提示信息
    a7: 'Bullet frame multiple choice',
    a8: 'Tips',
    a9: 'Matching failure prompt box',
    // * 看开始的地方 aa…… 在上面
    add_adjustmentListDetails: 'Add A New Adjustment Sheet Detail', // 新增应付调整单明细
    batchImport: 'Batch Import', //批量导入
    blacklist: 'Add To The Blacklist', //加入黑名单
    data: 'Data', //数据
    deleteDetails: 'Delete The Details', //删除明细
    error: 'Error', // 错误
    import: 'IMPORT', //导入
    manualWarehous: 'Manual Warehousing', //手动入库
    matrixEntry: 'Matrix Entry', //矩阵录入
    modify_logisticsCompany: 'Modify The Logistics Companies', //修改物流公司
    modify_returnWarehouse: 'Modify The Return Warehouse', //修改退货仓库
    modify_sellerNotes: "Modify The Seller's Notes", //修改卖家备注
    modify_shipping_address: 'Modify The Shipping Receipt Address', //修改收货地址
    newReturnDetails: 'New Return Details', //新增退货明细
    orderDownload: 'Order Download', // 订单下载
    originalChargebackDetails: 'Original Check-back Details', // 原始退单明细
    query_OriginalOrderNo: 'Query The Original Order Number', // 查询原始订单编号
    select_logisticsCompany: 'Please Select A Logistics Company', // 请选择物流公司
    sortForm: 'Sort The Forms', //排序表单
    tips: 'Tips', //提示
    title: 'Title', // 标题
    warning: 'WARNINGRNING', //警告
    postpone: 'Postpone', //延期
    z0: 'Inventory Is Synchronized By Query Criteria', // 库存按查询条件同步
    z1: 'The Goods Are Synchronized By The Query Conditions', // 商品按查询条件同步
  },

  tip: tipsMessage,
}